import { useEffect } from 'react';
import { captureAttribution, attributionMode } from '../data/attribution';
import { studioTrack } from '../data/studioPixel';
import { landingMode, LANDING_DEFAULT } from '../enums/landing';
import { STUDIO_HOME } from '../enums/routes';

// The Studio pixel's funnel events (diagnostics only: the campaign optimizes on the server's
// CompleteRegistration) and the ad attribution kept on arrival. A single-page app: the
// PageView goes out on every entry into the home, not only on the first load.
export default function useStudioTracking({ location, landing }) {
  const home = [STUDIO_HOME, `${STUDIO_HOME}/`].includes(location.pathname);

  useEffect(() => { captureAttribution(); }, [location.search]);

  useEffect(() => { if (home) studioTrack('PageView'); }, [home]);

  useEffect(() => {
    if (!landing) return;
    const mode = landingMode(location.search);
    studioTrack('ViewContent', { content_name: 'studio_landing', content_category: mode !== LANDING_DEFAULT ? mode : attributionMode() || 'health' });
  }, [landing]); // eslint-disable-line react-hooks/exhaustive-deps
}
